<template>
  <div class="middle cadfm-flexitem-stretched">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button @click="back" icon="back" bold :text="lang.button_Back" :tooltip="lang.button_Back"
            :disabled="backButtonStatus" />

          <action-button v-show="buttonStatus == 0" @click="exportCsv" icon="exportdata" bold :text="lang.button_ExportCsv" :tooltip="lang.button_ExportCsv" :disabled="exportCsvButtonStatus" />
          <action-button v-show="buttonStatus == 0" @click="exportFiles" icon="exportdata" bold :text="lang.button_ExportFiles" :tooltip="lang.button_ExportFiles" :disabled="exportFilesButtonStatus" />

          <action-button v-show="buttonStatus == 0" v-if="isPlugin && isAgent" @click="importing" icon="import" bold :text="lang.button_Import" :tooltip="lang.button_Import" :disabled="importButtonStatus" />
          <action-button v-show="buttonStatus == 0" @click="approving" icon="import" bold :text="lang.button_Approve" :tooltip="lang.button_Approve" :disabled="approveButtonStatus" />


        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold
            :text="lang.button_Left" :tooltip="lang.button_Left" :disabled="toggleButtonStatus" />
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold
            :text="lang.button_Right" :tooltip="lang.button_Right" :disabled="toggleButtonStatus" />

        </b-navbar-nav>
      </action-bar>
      <action-content>
        <Content :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
  import ActionBar from '@/components/shared/ActionBar'
  import ActionButton from '@/components/shared/ActionButton'
  import ActionContent from '@/components/shared/ActionContent'
  import ActionPanel from '@/components/shared/ActionPanel'


  import Content from "@/components/LibraryManager/Views/LibraryImport/Middle/Content/Content"
  import { mapGetters } from 'vuex'
import { forEach } from 'jszip/lib/object'


export default {
  name: 'Middle',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content

  },
  props:{
    lang: Object
  },

  data () {
    return {
      toggleButtonStatus: false,
      importButtonStatus: true,
      exportCsvButtonStatus: false,
      exportFilesButtonStatus: false,
      approveButtonStatus: true,
      backButtonStatus: false,
      imported: false,
      buttonStatus: 0,
      delimiter: ",",
      types: [],
      libCounter: 0,
      libs: [],
    }
  },
  computed:{
    ...mapGetters({

      isPlugin: 'isPlugin',
      isAgent: 'isAgent',

    }),
    lengthMapped(){

      if (this.$store.getters.importLibraryArray.length > 0){
        this.importButtonStatus = false;

      }else{
        this.importButtonStatus = true;

      }
      if (this.$store.getters.importLibraryArray.length > 0){
        this.approveButtonStatus = false;

      }else{
        this.approveButtonStatus = true;

      }
      return this.$store.getters.importLibraryArray.length;
    },


  },
  created() {

    this.importButtonStatus = true;
  },
  watch: {
    lengthMapped: function(newVal){

      if (newVal > 0){
        this.importButtonStatus = false;

      }else{
        this.importButtonStatus = true;

      }
      if (newVal > 0){
        this.approveButtonStatus = false;

      }else{
        this.approveButtonStatus = true;

      }

    },


  },
  methods: {
    cleanResult(){

      let r = document.getElementsByClassName("result-box");
      for (let i = 0; i < r.length; i++) {

        r[i].innerHTML = ""


      }
    },
    importLibrary(libraryObj){

      this.$store.dispatch("showLoader", {visible: true, text: "push"});
      let index = null;

      this.$store.commit("SETIMPORTLIBCURRENTOBJECT", libraryObj);



      let vue = this;

      //let lei = vue.$store.getters.libraryFilesToSaving.length;



      const obj = {
        revisionId: libraryObj.revisionId,
        type: libraryObj.type,
        name: libraryObj.name,
        category: libraryObj.category,
        path: libraryObj.path,
      }


      this.$store.dispatch(this.$store.getters.sectionPrefix + "_pushLibrary", obj)
      .then((result) => {


        console.log(result);
        if (result.data == null){
          result.data = {};
          result.data.fileImportResults = null;
          result.data.message = result.message;

          const obj = {
            name: libraryObj.name,
            type: libraryObj.type,
            file: "",
            message: result.message,
          }

          this.$store.dispatch(this.$store.getters.sectionPrefix + "_logImportError", obj)
          .then((result) => {
            console.log(result);
          })
        }

        result.data.name = libraryObj.name;
        result.data.type = libraryObj.type;

        this.$store.commit("SETIMPORTLIBCURRENTOBJECT_RESULT", result.data);


        vue.libCounter++;

        if (vue.libCounter > vue.$store.getters.dataLibrariesAfterBulkImport.length - 1){

          console.log("The end of loading libs.")

          vue.$store.dispatch("showLoader", {visible: false, text:""});
          vue.approveButtonStatus = false;


        }else{

          vue.importLibrary(vue.libs[vue.libCounter]);
        }

      })




    },
    processImportingLibs(){
      let vue = this;

      vue.libs = this.$store.getters.dataLibrariesAfterBulkImport;
      this.$store.commit("SETIMPORTLIBCURRENTOBJECT", {});
      this.$store.commit("SETIMPORTLIBCURRENTOBJECT_RESULT", null);

      if (vue.libs.length > 0){

        this.libCounter = 0;

        this.importLibrary(vue.libs[this.libCounter]);


      }



    },

    switchButtons(index){
      this.buttonStatus = index;
    },
    exportCsv() {

      this.$store.dispatch("showLoader", { visible: true, text: "download" });
      let vue = this;

      let obj = {
        categoryId: this.$store.getters.selectedTreeLibraryItemObject.categoryId

      };

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getLibrariesCSVFile", obj)
      .then(result => {
        //console.log(result);
        let fileName = "Libraries.csv";

        const blob = new Blob([result.data], {type: "text/csv"});

        let a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = fileName;

        document.body.appendChild(a);

        a.click();
        document.body.removeChild(a);
        vue.$store.dispatch("showLoader", { visible: false });
      })
      .then(function() {
        vue.$store.dispatch("showLoader", { visible: false });
      });

    },
    exportFiles() {

      this.$store.dispatch("showLoader", { visible: true, text: "download" });
      let vue = this;

      let obj = {
        categoryId: this.$store.getters.selectedTreeLibraryItemObject.categoryId

      };

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getLibrariesFilesForUpdate", obj)
      .then(result => {
        console.log(result);
        let fileName = "Libraries.zip";

        //const blob = new Blob([result.data], {type: "text/csv"});

        let a = document.createElement("a");
        a.href = URL.createObjectURL(result.data);
        a.download = fileName;

        document.body.appendChild(a);

        a.click();
        document.body.removeChild(a);
        vue.$store.dispatch("showLoader", { visible: false });
      })
      .then(function() {
        vue.$store.dispatch("showLoader", { visible: false });
      });


    },
    importing(){

      let _vue = this;

      this.approveButtonStatus = true;
      this.$store.commit("SETIMPORTLIBCURRENTOBJECT_RESULT", {});
      this.cleanResult();

      this.$store.commit("DELETEPROCESSDATAAFTERBULKIMPORT");
      this.$store.commit("DELETEPROCESSDATAAFTERBULKAPPROVE");



      this.$store.dispatch("showLoader", {visible: true, text: "load"});

      const arr = this.$store.getters.importLibraryArray;

      this.$store.dispatch(this.$store.getters.sectionPrefix+"_importLibrariesBulk", arr)
        .then(function(result){

          console.log(result.data)


          _vue.$store.dispatch("showLoader", {visible: false});

          if (result.status == "OK"){

            _vue.imported = true;

            if (result.data.length > 0){

              let obj = {
                text: _vue.lang.alert_success_importLibrariesBulk,
                time: 5,
                type: "success"
              }

              //_vue.$store.dispatch("displayFooterAlert", obj)

              _vue.$store.commit("PROCESSDATAAFTERBULKIMPORT", result.data);

              _vue.processImportingLibs();

            }else {


              let obj = {
                text: _vue.lang.alert_error_importLibrariesBulk,
                time: 15,
                type: "warning"
              }

              _vue.$store.dispatch("displayFooterAlert", obj)

            }


          }else{

            let obj = {
              text: _vue.lang.alert_error_importLibrariesBulk + result.message,
              time: 15,
              type: "danger"
            }

            _vue.$store.dispatch("displayFooterAlert", obj)


          }



      })
      .then(function() {

        _vue.$store.dispatch("showLoader", {visible: false});

      })



    },
    approving() {


      let _vue = this;

      this.$store.dispatch("showLoader", {visible: true, text: "load"});

      let importLibraryArray = this.$store.getters.importLibraryArray;

      const arr = importLibraryArray.map(({ name, type }) => ({
        name,
        type
      }));


      this.$store.dispatch(this.$store.getters.sectionPrefix+"_approveLibraryBulk", arr)
        .then(function(result){

          console.log(result.data)

          _vue.$store.dispatch("showLoader", {visible: false});

          if (result.status == "OK"){


            if (result.data.length > 0){

              let obj = {
                text: _vue.lang.alert_success_approveLibrariesBulk,
                time: 5,
                type: "success"
              }

              _vue.$store.dispatch("displayFooterAlert", obj)

              _vue.$store.commit("PROCESSDATAAFTERBULKAPPROVE", result.data);



            }else {

              let obj = {
                text: _vue.lang.alert_error_approveLibrariesBulk,
                time: 15,
                type: "warning"
              }

              _vue.$store.dispatch("displayFooterAlert", obj)

            }


          }else{

            let obj = {
              text: _vue.lang.alert_error_approveLibrariesBulk + result.message,
              time: 15,
              type: "danger"
            }

            _vue.$store.dispatch("displayFooterAlert", obj)


          }



      })
      .then(function() {

        _vue.$store.dispatch("showLoader", {visible: false});

      })



    },



    back(){


      if (this.imported){
        const reloadObj = {
            status: true,
            name: "DataTableFilteredOnApiComponent"
        }
        this.$store.dispatch("reloadAfterActionComplex", reloadObj);


      }

      let to = this.$route.query.from;




      const query = {
        from: this.$route.path,
        to: to,

      }

      this.$router.push({ path: to, query: query });
    },
    toggleRightPanel(){

      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;

    },
    toggleLeftPanel(){

      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;

    }
  }
}
</script>


<style scoped>

  .middle{
    border-right: 1px solid #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/Views/LibraryImport/Middle/Middle.vue